import { Paper } from "@mui/material";
import { SecondaryNavLink } from "components/SecondaryNavLink";

export type VerticalNavigationTabsGroup = {
  items: VerticalNavigationTabsItem[];
  label?: string;
};

type VerticalNavigationTabsItem = {
  disabled?: boolean;
  id: string;
  label: string;
};

type VerticalNavigationTabsProps = {
  activeTab: string;
  className?: string;
  groups: VerticalNavigationTabsGroup[];
  setActiveTab: (tabId: string) => void;
};

const isGroupedLayout = (groups: VerticalNavigationTabsGroup[]) =>
  groups.length > 1 || groups.some((group) => Boolean(group.label));

type NavMenuItemRowProps = {
  isActive: boolean;
  isDisabled?: boolean;
  label: string;
  onSelect: () => void;
};

const NavMenuItemRow = ({ isActive, isDisabled, label, onSelect }: NavMenuItemRowProps) => (
  <li
    className="mt-2 px-2"
    onClick={() => {
      if (!isDisabled) onSelect();
    }}
  >
    <SecondaryNavLink className="h-10 w-full" isActive={isActive} isDisabled={isDisabled} onClick={() => {}}>
      {label}
    </SecondaryNavLink>
  </li>
);

type VerticalNavigationTabsGroupSectionProps = {
  activeTab: string;
  group: VerticalNavigationTabsGroup;
  setActiveTab: (tabId: string) => void;
  showGroupLabel: boolean;
};

const VerticalNavigationTabsGroupSection = ({
  activeTab,
  group,
  setActiveTab,
  showGroupLabel,
}: VerticalNavigationTabsGroupSectionProps) => (
  <li>
    {showGroupLabel && group.label ? (
      <h3 className="font-ds-headline-sm border-b-ds-softest px-4 py-2 text-lds-foreground-primary">{group.label}</h3>
    ) : null}
    <ul className="mb-4">
      {group.items.map((item) => (
        <NavMenuItemRow
          isActive={item.id === activeTab}
          isDisabled={item.disabled}
          key={item.id}
          label={item.label}
          onSelect={() => setActiveTab(item.id)}
        />
      ))}
    </ul>
  </li>
);

export const VerticalNavigationTabs = ({ activeTab, className, groups, setActiveTab }: VerticalNavigationTabsProps) => {
  const showGroupLabels = isGroupedLayout(groups);

  return (
    <Paper className={className}>
      <ul className="mb-4">
        {groups.map((group, index) => (
          <VerticalNavigationTabsGroupSection
            activeTab={activeTab}
            group={group}
            key={group.label ?? index}
            setActiveTab={setActiveTab}
            showGroupLabel={showGroupLabels}
          />
        ))}
      </ul>
    </Paper>
  );
};
